import { GetterTree } from 'vuex';
import { IGroupCategoryInfo, State } from '@/store/modules/group/state';
import { RootState } from '@/store/index';
import { ChannelBaseInfo, GroupInfo, AdvConfList, EntranceConfList } from '_c/typings/proto';

const getters: GetterTree<State, RootState> = {
  currentGroup(state): GroupInfo | undefined {
    return state.groupList.find(group => group.info.gid === state.selectGroupId);
  },
  currentChannel(state): ChannelBaseInfo | undefined {
    const currentChannelList = state.channelList[state.selectGroupId];
    return currentChannelList?.find(channel => channel.cid === state.selectChannelId);
  },
  currentChannelList(state): Array<ChannelBaseInfo> | undefined {
    return state.channelList[state.selectGroupId];
  },
  currentChannelListWithCategory(state): Array<IGroupCategoryInfo> | undefined {
    return state.channelListWithCategory[state.selectGroupId];
  },
  // 根据群组id返回推广位信息
  currentPromotionData(state): AdvConfList | undefined {
    return state.promotionList[state.selectGroupId];
  },
  // 根据群组id返回中心化入口信息
  currentCenterEntranceData(state): EntranceConfList | undefined {
    return state.centerEntranceList[state.selectGroupId];
  },
  groupAtCountList(state): Record<string, number> {
    return state.groupList.reduce((ret: Record<string, number>, group) => {
      const groupId = group.info.gid;
      const channelList = state.atCountList[groupId] || {};
      // eslint-disable-next-line no-param-reassign
      ret[groupId] = Object.keys(channelList).reduce((ret, channelId) => {
        // eslint-disable-next-line no-param-reassign
        ret += channelList[channelId] || 0;
        return ret;
      }, 0);
      return ret;
    }, {});
  },
  groupUnreadCountList(state): Record<string, number> {
    return state.groupList.reduce((ret: Record<string, number>, group) => {
      const groupId = group.info.gid;
      const channelList = state.unreadCountList[groupId] || {};
      // eslint-disable-next-line no-param-reassign
      ret[groupId] = Object.keys(channelList).reduce((ret, channelId) => {
        // eslint-disable-next-line no-param-reassign
        ret += channelList[channelId] || 0;
        return ret;
      }, 0);
      return ret;
    }, {});
  },
  channelToGroupMap(state): Record<string, string> {
    const ret: Record<string, string> = {};
    Object.keys(state.channelList).forEach((groupId) => {
      state.channelList[groupId].forEach((channel) => {
        ret[channel.cid] = groupId;
      });
    });
    return ret;
  },
};

export default getters;
